<template>
  <OrderTestDialog
    class="x-choose-y-dialog"
    :title="title"
    :is-show-dialog="isShowDialog"
    :width="width"
    :show-footer="false"
    @close="$emit('close')"
  >
    <BuildYourBundleBanner 
      v-if="anyThreePromo || anyFivePromo"
      :select-quantity="selectedTestQuantity" 
      :quantity="quantity" 
      :select-test-price="selectTestPrice"
      :promo-price="promoPrice"
      :is-unable-to-form-promo="isUnableAbleToFormPromo"
      :select-tests="selectedItemList"
      :any-three-promo="anyThreePromo"
      :any-five-promo="anyFivePromo"
      :selected-vw-test-price="selectedVwTestPrice"
      @isAddToCart="$emit('isAddToCart', { selectedTestIdList, dbsToggle })"
    />
    <div v-if="showDealAlert" class="mt-7">
      <Alert :height="48" class="flex items-center mb-2" v-if="isUnableToFormPromo">
        <p class="ml-3">
          {{
            selectedTestQuantity === 3
              ? $t("OrderPage[\"Unfortunately, your selected bundle is less than ${currency.symbol}${anyThreePromo.price}. You can either continue to process the bundle or modify what you selected.\"]", { symbol: currency.symbol, price: anyThreePromo.price })
              : $t("OrderPage[\"Unfortunately, your selected bundle is less than ${currency.symbol}${anyFivePromo.price}. You can either continue to process the bundle or modify what you selected.\"]", { symbol: currency.symbol, price: anyFivePromo.price })
          }}
        </p>
      </Alert>
      <Alert type="success" :height="48" class="flex items-center mb-2 justify-between" v-if="suggestBundle&&suggestBundle.appliedBundleId & selectedTestQuantity < 5">
        <p class="ml-3 add-deal-alert-text">{{ $t("OrderPage[\"🎉 Big savings alert! Get this special combo for just\"]") }}<span class="font-bold">{{currency.symbol}}{{ suggestBundle.bundlePrice }}</span>{{ $t("OrderPage[\"(was {currency.symbol}{ suggestBundle.originalPrice }) - or continue to build your bundle\"]", { symbol: currency.symbol, originalPrice: suggestBundle.originalPrice }) }} </p>
        <p class="mr-3 add-deal-btn" @click="handleAddDeal">{{ $t("OrderPage[\"Add Deal\"]") }}</p>
      </Alert>
    </div>
    <DbsSwitch 
      v-if="showDbsSwitch"
      class="mt-3 mx-3"
      :dbs-toggle="dbsToggle" 
      @change="changeDbsVersion" 
    >
      <template #content>
        &nbsp;&nbsp;&nbsp;Show only tests available for home collection
      </template>
    </DbsSwitch>
    <div class="grid grid-cols-3 gap-x-5 p-3" v-if="!dbsToggle">
      <div v-for="column in 3" :key="column" class="flex flex-col gap-y-3">
        <ThreeFor700TestCard 
          v-for="(category, index) in categorizedNodeList.slice(2 * (column - 1), 2 * column)" 
          :key="category.categoryId" 
          :title="category.categoryName"
          :test-node-list="category.testNodeList"
          :remaining-quantity="remainingTestQuantity"
          select-prop="isSelectForXChooseY"
          is-not-allowed-select-prop="isNotAllowedSelectForXChooseY"
          :order-test-supportObj="supportObj"
          :selected-vw-test-price="selectedVwTestPrice"
          :disabled-x-choose-y-panel-test-ids="disabledXChooseYPanelTestIds"
          :class="{ 'h-full' : index === 1 }"
        />
      </div>
    </div>
    <div class="grid grid-cols-3 gap-x-5 p-3" v-else>
      <div class="flex flex-col gap-y-3">
        <ThreeFor700TestCard 
          v-for="(category, index) in categorizedNodeList.slice(0, 3)" 
          :key="category.categoryId" 
          :title="category.categoryName"
          :test-node-list="category.testNodeList"
          :remaining-quantity="remainingTestQuantity"
          select-prop="isSelectForXChooseY"
          is-not-allowed-select-prop="isNotAllowedSelectForXChooseY"
          :order-test-supportObj="supportObj"
          :selected-vw-test-price="selectedVwTestPrice"
          :disabled-x-choose-y-panel-test-ids="disabledXChooseYPanelTestIds"
          :class="{ 'h-full' : index === 2 }"
        />
      </div>
      <div class="flex flex-col gap-y-3">
        <ThreeFor700TestCard 
          v-for="(category, index) in categorizedNodeList.slice(3, 6)" 
          :key="category.categoryId" 
          :title="category.categoryName"
          :test-node-list="category.testNodeList"
          :remaining-quantity="remainingTestQuantity"
          select-prop="isSelectForXChooseY"
          is-not-allowed-select-prop="isNotAllowedSelectForXChooseY"
          :order-test-supportObj="supportObj"
          :selected-vw-test-price="selectedVwTestPrice"
          :disabled-x-choose-y-panel-test-ids="disabledXChooseYPanelTestIds"
          :class="{ 'h-full' : index === 2 }"
        />
      </div>
      <div class="flex flex-col gap-y-3">
        <ThreeFor700TestCard 
          v-for="(category, index) in categorizedNodeList.slice(6)" 
          :key="category.categoryId" 
          :title="category.categoryName"
          :test-node-list="category.testNodeList"
          :remaining-quantity="remainingTestQuantity"
          select-prop="isSelectForXChooseY"
          is-not-allowed-select-prop="isNotAllowedSelectForXChooseY"
          :order-test-supportObj="supportObj"
          :selected-vw-test-price="selectedVwTestPrice"
          :disabled-x-choose-y-panel-test-ids="disabledXChooseYPanelTestIds"
          :class="{ 'h-full' : index === 3 }"
        />
      </div>
    </div>
  </OrderTestDialog>
</template>

<script>
import BuildYourBundleBanner from "./BuildYourBundleBanner.vue";
import OrderTestDialog from "../../../components/OrderTestDialog.vue";
import ThreeFor700TestCard from "./ThreeFor700TestCard.vue";
import Alert from '../../../components/Alert.vue';
import DbsSwitch from "../../order-test-panel/DbsSwitch.vue";
import { mapGetters, mapState } from "vuex";
import { handleException } from "@/utils/va-order-test/testAndPanelSelection/handleException";
import { handleDuplicateTests } from "@/utils/va-order-test/testAndPanelSelection/handleDuplicateTests";
import { clearAllSelectedItems, getSuggestBundlesAndLeftOverTests, getTestIdsForBestDealFunc } from "@/utils/va-order-test/bestDealSuggestion";
import { getVwTestsPrice, applyConditionalDiscounts } from "@/utils/va-order-test";
import { addSelectedDiscountPanel } from "@/utils/va-order-test/testAndPanelSelection/discountPanelSelection.js";
import { cloneOrderTestTreeAndBundles } from "@/store/modules/va-order-test/helpers/deepCopyHelpers";
import _ from "lodash";
import { addSelectedTest, removeSelectedTest } from "@/utils/va-order-test/testAndPanelSelection/testSelection";
import { bfsSearch } from "@/utils/va-order-test/testTree/bfsSearch";
import { removeItem } from "@/utils/va-order-test/testAndPanelSelection";

export default {
  emits: ["close", "isAddToCart"],
  components: {
    OrderTestDialog,
    ThreeFor700TestCard,
    Alert,
    BuildYourBundleBanner,
    DbsSwitch
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    isShowDialog: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 724
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },
    quantity: {
      type: Number,
      default: 0
    },
    promoPrice: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0
    },
    showDealAlert: {
      type: Boolean,
      default: false
    }
  },

  data() {
    const deepCopies = cloneOrderTestTreeAndBundles();
    
    return {
      isUnableAbleToFormPromo: false,
      input: "",
      sortBy: "nameAscending",
      sortByOptions: [{
        label: this.$t("OrderPage[\"Product Name A to Z\"]"),
        value: "nameAscending"
      }, {
        label: this.$t("OrderPage[\"Product Name Z to A\"]"),
        value: "nameDescending"
      }],
      selectedTestIdList: [],
      selectTestPrice: 0,
      suggestBundle: {
        appliedBundleId: null,
        bundlePrice: 0,
        originalPrice: 0
      },
      dbsToggle: this.$store.state.orderTest.isDbsVersion,
      disabledXChooseYPanelTests: [],
      ...deepCopies
    }
  },

  mounted() {
    this.initializeNodeSelection();
    this.updateSelectTestsInfo();
  },

  computed: {
    ...mapState(["currency"]),
    ...mapState("orderTest", ["discountMap", "dbsMap"]),
    ...mapState("orderTest/user", ["userInfo"]),
    ...mapState("orderTest/exceptions", ["exceptionMap"]),
    ...mapGetters("orderTest", ["orderTestSupportObj"]),
    ...mapGetters("orderTest/favorites", ["itemsInSelectedShortcuts"]),

    
    selectedTestQuantity() {
      return this.selectedTestIdList.length;
    },

    remainingTestQuantity() {
      return this.quantity - this.selectedTestQuantity;
    },

    isUnableToFormPromo() {
      if((this.selectedTestQuantity === 3 && this.selectTestPrice < this.anyThreePromo.price) || (this.selectedTestQuantity === 5 && this.selectTestPrice < this.anyFivePromo.price) ) {
        return true
      } 
      return false
    },
    anyThreePromo() {
      return this.discountPanelList.find(discount =>  discount.bundleId === (this.dbsToggle ? 4 : 2))
    },
    anyFivePromo() {
      return this.discountPanelList.find(discount => discount.bundleId === (this.dbsToggle ? 5 : 3))
    },
    supportObj() {
      return {
        testNodeList: this.bfsTestList,
        bundleList: this.bundleList,
        seasonalPromotionList: [],
        shortcutList: [],
        exceptionMap: this.exceptionMap,
        dbsMap: this.dbsMap,
        selectedTestIdList: this.selectedTestIdList,
        selectedDiscountPanelIdList: [],
        selectedXChooseYPanelIdList: [],
        selectedCustomPanelIdList: [],
        selectedSeasonalPromoList: [],
        selectedShortcutIdList: [],
        selectedItemList: this.selectedItemList,
        selectedVwTestPrice: this.selectedVwTestPrice,
        isFavPanelOpen: true,
        editOrderItemList: [],
        bestDealSupportMapping: this.orderTestSupportObj.bestDealSupportMapping
      };
    },
    selectedItemList() {
      return this.testList.filter(t => this.selectedTestIdList.includes(t.id));
    },
    
    // price for ordered vw tests - inlclude bundle contaning vw tests
    selectedVwTestPrice(){
      return getVwTestsPrice(this.selectedItemList, this.vwTestList) + getVwTestsPrice(this.orderTestSupportObj.selectedItemList, this.vwTestList);
    },

    categorizedNodeList() {
      // Make this reactive by calling getCategorizedRootList directly
      // This ensures selection state changes are reflected in the UI
      return this.getCategorizedRootList(this.dbsToggle);
    },

    bfsNodeList() {
      let nodeList = this.categorizedNodeList.map(category => category.testNodeList)
        .reduce((acc, nodeList) => acc.concat(nodeList), []);
      let bfsNodeList = [];
      nodeList.forEach(node => bfsSearch(node, bfsNodeList, node.level));
      return bfsNodeList;
    },
    
    disabledXChooseYPanelTestIds() {
      return this.disabledXChooseYPanelTests.map(node => node.id);
    },
    // show dbs switch if backend has not_at_home tests
    showDbsSwitch() {
      if (this.testList.some(item => item.section === 'not_at_home')) return true;
      return false;
    }
  },

  watch: {
    selectedItemList() {
      const mainItemList = (this.orderTestSupportObj.selectedItemList || []).filter(i => i.category !== "shortcut").concat(this.itemsInSelectedShortcuts || []);
      const itemListForTriggerPrice = this.selectedItemList.concat(mainItemList);
      applyConditionalDiscounts(this.testList, "isSelect", itemListForTriggerPrice);
      this.updateSelectTestsInfo()
    },
    selectedTestQuantity(newVal) {
      let anyThreePromoPrice = this.anyThreePromo ? this.anyThreePromo.price : null
      let anyFivePromoPrice =  this.anyFivePromo ? this.anyFivePromo.price : null
      if((newVal === 3 && anyThreePromoPrice && this.selectTestPrice < anyThreePromoPrice) || (newVal === 5 && anyFivePromoPrice && this.selectTestPrice < anyFivePromoPrice) ) {
        this.isUnableAbleToFormPromo = true
      } 
    }
  },

  methods: {
    getCategorizedRootList(dbsVersion) {
      let promoCategorizedList = [];
      let promo = this.discountPanelList.find(discount => discount.bundleId === (dbsVersion ? 5 : 3))
      if (!promo) {
        return [];
      }
      let promoTestIds = promo.testIdsInPanel;
      const categorizedVwTests = dbsVersion ? this.dbsCategorizedVwTests : this.serumCategorizedVwTests;
      categorizedVwTests.forEach(category => {
        let { categoryId, categoryName, index, testNodeList } = category;
        let promoTestNodesInCategory = testNodeList.filter(node => promoTestIds.includes(node.id) || node.descendants.some(d => promoTestIds.includes(d.id)));
        if (!dbsVersion) {
          // remove at-home tests, since testNodeList includes "both" and "at-home" nodes when in non-dbs menu
          promoTestNodesInCategory = promoTestNodesInCategory.filter(node => node.value.section !== "at_home");
        }
        if (promoTestNodesInCategory.length > 0) {
          promoCategorizedList.push({
            categoryId,
            categoryName,
            index,
            testNodeList: promoTestNodesInCategory
          });
        }
      })
      let serumCategoryOrder = [1, 2, 4, 8, 6, 11];
      let dbsCategoryOrder = [0, 1, 7, 2, 4, 3, 6, 11, 8, 9];
      let order = dbsVersion ? dbsCategoryOrder : serumCategoryOrder;
      let sortedCategorizedList = _.sortBy(promoCategorizedList, function (category) {
        return _.indexOf(order, category.index);
      });
      // console.log("sortedCategorizedList", sortedCategorizedList);
      return sortedCategorizedList;
    },

    initializeNodeSelection() {
      // initialize test list selection status used for promo
      // light up the selected tests and those included in selected discount panels
      this.bfsNodeList.forEach(node => {
        node.value.isSelectForXChooseY = false;
        node.value.isNotAllowedSelectForXChooseY = false;
      });
      // disable nodes that are not belong to 3 for 700 or 5 for 1000 pools
      let promoTestIds = this.discountPanelList.filter(panel => [3, 5].includes(panel.bundleId))
        .map(panel => panel.testIdsInPanel)
        .reduce((acc, testIds) => acc.concat(testIds), []);
      this.bfsNodeList.forEach(node => !promoTestIds.includes(node.id) && (node.value.isNotAllowedSelectForXChooseY = true));
      // select single tests and tests in discount panels that are already selected
      // if selected test is not in the pool, then select all its descendants instead
      let { selectedTestIdList, selectedItemList  } = this.orderTestSupportObj;
      this.bfsNodeList.filter(node => selectedTestIdList.includes(node.id))
        .forEach(node => {
          if (!promoTestIds.includes(node.id)) {
            node.descendants.forEach(d => addSelectedTest(d.id, "isSelectForXChooseY", this.supportObj));
          } else {
            addSelectedTest(node.id, "isSelectForXChooseY", this.supportObj);
          }
        });
      let selectedDiscountPanels = selectedItemList.filter(item => item.category === "discountPanel");
      selectedDiscountPanels.forEach(panel => {
        this.bfsNodeList.filter(node => panel.testIdsInPanel.includes(node.id))
          .forEach(node => {
            if (!promoTestIds.includes(node.id)) {
              node.descendants.forEach(d => addSelectedTest(d.id, "isSelectForXChooseY", this.supportObj));
            } else {
              addSelectedTest(node.id, "isSelectForXChooseY", this.supportObj);
            }
          });
      });
      // for x choose y panels, select and disabled them
      selectedItemList.filter(item => item.category === "xChooseY").forEach(item => {
        let { selectedZoomerIdList, selectedSupplementIdList } = item;
        let testIdsInPanel = (selectedZoomerIdList ? selectedZoomerIdList : [])
          .concat((selectedSupplementIdList ? selectedSupplementIdList : []));
        if (this.selectedTestQuantity + item.quantity < 5) {
          // tests in these x choose y panel can be used to form 5 for 1000
          // currently the only possible x choose y panel is 3 for 700
          this.bfsNodeList.filter(node => testIdsInPanel.includes(node.id))
            .forEach(node=> {
              addSelectedTest(node.id, "isSelectForXChooseY", this.supportObj);
              node.value.isNotAllowedSelectForXChooseY = false;
              node.descendants.forEach(d => {
                d.value.isNotAllowedSelectForXChooseY = false;
              });
            });

        } else {
          this.bfsNodeList.filter(node => testIdsInPanel.includes(node.id))
            .forEach(node => {
              node.value.isSelectForXChooseY = true;
              node.value.isNotAllowedSelectForXChooseY = true;
              node.descendants.forEach(d => {
                d.value.isSelectForXChooseY = true;
                d.value.isNotAllowedSelectForXChooseY = true;
              });
            });
          // save the disabled x choose y panel tests for later use
          this.disabledXChooseYPanelTests = this.disabledXChooseYPanelTests
            .concat(this.bfsNodeList.filter(node => testIdsInPanel.includes(node.id)));
          this.disabledXChooseYPanelTests = [...new Set(this.disabledXChooseYPanelTests)]; //remove duplicate
        }
      });
    },
    
    updateSelectTestsInfo() {
      let suggestBundle = this.findBestDeal(this.selectedTestIdList);
      this.disableExceptionTestsInDisabledXChooseYPanels();
      if (suggestBundle && !suggestBundle.originalPrice) {
        suggestBundle.originalPrice = this.selectedItemList.reduce((acc, test) => acc + test.price, 0);
      }
      // hide big saving alert for 3For700, 5For1000 bundles
      if (suggestBundle && [2, 3, 4, 5].includes(suggestBundle.appliedBundleId)) {
        this.suggestBundle = null;
      } else {
        this.suggestBundle = suggestBundle;
      }
      // temporarily not consider supplement list to see if it works
      this.selectTestPrice = this.suggestBundle ? this.suggestBundle.bestDealPrice : this.selectedItemList.reduce((acc, item) => acc + item.price, 0);
    },
    findBestDeal(newValue) {
      // handle exceptions
      handleException("isSelectForXChooseY", "isNotAllowedSelectForXChooseY", this.supportObj);
      // console.log("after exception", [...this.selectedTestIdList])
      handleDuplicateTests("isSelectForXChooseY", this.supportObj);
      // console.log("after duplicate tests", [...this.selectedTestIdList])
      if (newValue.length === 0) {
        return null;
      }
      // get ids for selected test, test in selected custom, discount and x choose y panel
      let testIds = getTestIdsForBestDealFunc(this.supportObj);
      // console.log("testIds", testIds);
      if (testIds.length === 0) {
        return null;
      }
      let { suggestBundleList, leftOverTestIdList, bestDealPrice } = getSuggestBundlesAndLeftOverTests(testIds, this.supportObj, this.discountMap, this.dbsToggle, this.dbsToggle);
      this.replaceSelectedTestIdsWithBestDeal(suggestBundleList, leftOverTestIdList);
      // console.log(suggestBundleList);
      let bundleId = suggestBundleList[0] ? suggestBundleList[0].appliedBundleId : null;
      let suggestBundle = this.supportObj.bundleList.find(b => b.bundleId === bundleId);
      // console.log(suggestBundle)
      return suggestBundle ? {
        ...suggestBundleList[0],
        originalPrice: suggestBundle.originalPrice,
        bestDealPrice: bestDealPrice ? Number(bestDealPrice) : 0
      } : null;
    },
    handleAddDeal() {
      this.$emit("close");
      let { appliedZoomers, appliedSuuplement } = this.suggestBundle;
      if (appliedZoomers && appliedZoomers.length > 0) { // for suggested x choose y panel
        appliedZoomers.concat(appliedSuuplement ? appliedSuuplement : [])
          .forEach(id => addSelectedTest(id, "isSelect", this.orderTestSupportObj));
      } else { // for suggested discount panel
        addSelectedDiscountPanel(this.suggestBundle.appliedBundleId, "isSelect", this.orderTestSupportObj);
      }
    },
    changeDbsVersion(dbsVersion) {
      this.dbsToggle = dbsVersion;
      // clean current selection if not in changed menu;
      this.removeTestsNotInCurrentMenu();
    },
    disableExceptionTestsInDisabledXChooseYPanels() {
      let exceptionNodesInDisabledXChooseY = [];
      this.disabledXChooseYPanelTests.forEach(node => {
        if (node.value.exceptionType && node.value.exceptionType.includes("ADDITION_ENABLE")) {
          exceptionNodesInDisabledXChooseY.push(node);
        }
        node.descendants.forEach(d => {
          if (d.value.exceptionType && d.value.exceptionType.includes("ADDITION_ENABLE")) {
            exceptionNodesInDisabledXChooseY.push(d);
          }
        });
      });
      exceptionNodesInDisabledXChooseY.forEach(node => node.value.isNotAllowedSelectForXChooseY = true);
    },
    
    removeTestsNotInCurrentMenu() {
      let testIdsInCurrentMenu = this.bfsNodeList.map(node => node.id);
      let removedTestIds = this.selectedTestIdList.filter(id => !testIdsInCurrentMenu.includes(id));
      removedTestIds.forEach(id => removeSelectedTest(id, "isSelectForXChooseY", this.supportObj));
    },

    replaceSelectedTestIdsWithBestDeal(suggestBundleList, leftOverTestIdList) {
      let idList = [...leftOverTestIdList];
      suggestBundleList.forEach(bundle => {
        let { appliedBundleId, appliedZoomers } = bundle;
        if (appliedZoomers) {
          idList = idList.concat(bundle.appliedZoomers);
        } else {
          let discountPanel = this.discountPanelList.find(panel => panel.bundleId === appliedBundleId);
          idList = idList.concat(discountPanel.testIdsInPanel);
        }
      });
      // hardcode for total tox burden (828)
      // replace total tox burden with its three descendants
      // since total tox burden itself is not eligible for 3 for 700
      if (idList.includes(828)) {
        removeItem(828, idList);
        [719, 196, 181].forEach(id => idList.push(id));
      }
      // update test selection if best deal tests not same as currently selected tests
      let isSame = this.selectedTestIdList.length === idList.length 
          && idList.every(id => this.selectedTestIdList.find(id2 => id2 === id));
      if (!isSame) {
        clearAllSelectedItems("isSelectForXChooseY", this.supportObj);
        idList.forEach(id => addSelectedTest(id, "isSelectForXChooseY", this.supportObj));
      }     
    },
    
  }
}
</script>

<style scoped>
.add-deal-btn {
  display: flex;
  height: 30px;
  padding: var(--V-padding, 8px) var(--H-padding, 30px);
  justify-content: center;
  align-items: center;
  gap: var(--Spacing, 4px);
  border-radius: var(--radius, 4px);
  border: 1px solid #20A8C3;
  cursor: pointer;
  color: var(--color-Cyan-000, #20A7C1);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.add-deal-alert-text {
  color: black;
}

</style>